import { logger } from 'utils/logger'

import { meetsAxiosProtected as axios } from '../../services/httpInstance/http'
import {
    setQuizSets,
    setActiveQuestion,
    resetStateRequest,
} from '../actions/Quiz'
import { getQuizSetsUrl, getActiveQuestionUrl } from '../url/Quiz'

export const getQuizSets = () => {
    return dispatch => {
        axios
            .get(getQuizSetsUrl())
            .then(response => {
                if (response?.data?.sets) {
                    dispatch(setQuizSets(response.data.sets))
                }
            })
            .catch(error => {
                const logErrorMsg = `Failed to fetch list of sets.\nERROR: ${error.message}`
                logger.error(logErrorMsg)
            })
    }
}

export const getActiveQuestion = roomName => {
    return dispatch => {
        axios
            .get(getActiveQuestionUrl(roomName))
            .then(response => {
                if (response?.data?.quiz) {
                    const m = response.data

                    const { quiz, total, current, active_question } = m
                    const {
                        uuid,
                        question,
                        type,
                        topic,
                        choices,
                        timer,
                        question_end_time,
                        answers,
                    } = active_question

                    dispatch(
                        setActiveQuestion(
                            {
                                uuid: quiz,
                                total: total,
                                current: current,
                            },
                            {
                                uuid,
                                question,
                                type,
                                topic,
                                choices,
                                timer,
                                question_end_time,
                                answers,
                            }
                        )
                    )
                }
            })
            .catch(error => {
                const logErrorMsg = `Failed to fetch active question.\nERROR: ${error.message}`
                logger.error(logErrorMsg)
            })
    }
}

export const resetState = () => dispatch => dispatch(resetStateRequest())
